<template>
  <div class="content">
    <div class="container-fluid h-100">
      <div class="container-fluid h-100">
        <card-item>
          <div class="d-flex justify-content-end">
            <button class="btn btn-danger btn-sm" @click="volver">
              Volver
            </button>
          </div>
        </card-item>
        <div class="row h-100">
          <div v-if="!isLoading" class="col">
            <div class="col h-100">
              <form
                v-promise-btn="{ action: 'submit' }"
                @submit.prevent="submit"
              >
                <card-item>
                  <template>
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <h4 class="card-title">Crear contrato</h4>
                    </div>
                  </template>
                  <div class="container">
                    <div class="row">
                      <div class="col-12 col-md-6 form-group form-group-sm">
                        <label class="label" for="cliente">Cliente</label>
                        <input
                          id="cliente"
                          :value="nombreCliente"
                          :class="`form-control form-control-sm text-center bg-white`"
                          style="cursor: text"
                          type="text"
                        />
                      </div>
                      <div class="col-12 col-md-6 form-group form-group-sm">
                        <label class="label" for="fechaAlta"
                          >Fecha de alta</label
                        >
                        <input
                          id="fechaAlta"
                          v-model="fechaAlta"
                          :class="`form-control form-control-sm text-center bg-white`"
                          type="date"
                        />
                      </div>
                      <SelectGrupo
                        v-model="grupo"
                        @cantidadGrupos="cambiarCantidadGrupos"
                      />
                    </div>
                    <EmpresasFacturacionForm />
                    <div class="row">
                      <SelectTipoContrato v-model="contratoTipo" />
                      <div :class="`col-12 col-md-6 form-group form-group-sm`">
                        <label class="label" for="avlChip">AVL Chip</label>
                        <SelectAvlChip v-model="avlChip" />
                      </div>
                      <SelectVehiculo v-model="vehiculo" />
                    </div>
                    <VentaForm v-model="ventaNotas" />
                    <InstalacionForm />
                    <ViaticosForm v-model="viaticos" ref="viaticosForm" />
                    <div class="row">
                      <div class="col-12">
                        <div class="d-flex justify-content-between">
                          <button class="btn btn-secondary" @click="volver">
                            Cancelar
                          </button>
                          <button class="btn btn-primary" type="submit">
                            Aceptar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </card-item>
              </form>
            </div>
          </div>
          <div v-else class="col">...Cargando...</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store/store";
import SelectTipoContrato from "@/pages/Clientes/Contratos/Commons/SelectTipoContrato";
import SelectGrupo from "@/pages/Clientes/Contratos/Commons/SelectGrupo";
import EmpresasFacturacionForm from "../Contratos/Crear/EmpresasFacturacionForm.vue";
import SelectVehiculo from "@/pages/Clientes/Contratos/Commons/SelectVehiculo";
import SelectAvlChip from "@/pages/Clientes/Contratos/Commons/SelectAvlChip";
import VentaForm from "@/pages/Clientes/Contratos/Commons/VentaForm";
import InstalacionForm from "@/pages/Clientes/Contratos/Crear/InstalacionForm";

import { get, isNull } from "lodash-es";
import NombreCliente from "../shared/NombreCliente";
import axios from "axios";
import ViaticosForm from "../../../components/Viaticos/ViaticosForm.vue";

export default {
  name: "CrearContrato",
  mixins: [NombreCliente],
  async mounted() {
    this.isLoading = true;

    store.commit("Contratos/NuevoContrato/reinit");
    await this.getNombreCliente(this.$route.params.id_cliente);
    await this.initFacturacion();
    await this.initTipoContrato();

    this.isLoading = false;
  },
  components: {
    SelectVehiculo,
    SelectTipoContrato,
    SelectGrupo,
    EmpresasFacturacionForm,
    SelectAvlChip,
    VentaForm,
    InstalacionForm,
    ViaticosForm,
  },
  methods: {
    async initFacturacion() {
      const resp = await axios.post("/execute", {
        method: "CLI.GetEmpresasPredeterminadasByClienteId",
        parameters: [
          {
            name: "id_cliente",
            value: this.$route.params.id_cliente,
          },
        ],
      });

      if (resp.data.ok) {
        const idEmpresasPropias = get(
          resp.data,
          "result[0][0].id_empresas_propias",
          0,
        );
        const idEmpresa = get(resp.data, "result[0][0].id_empresa", null);
        const subfactura = get(resp.data, "result[0][0].subfactura", null);

        store.commit(
          "Contratos/NuevoContrato/setEmpresaPropia",
          idEmpresasPropias,
        );
        store.commit("Contratos/NuevoContrato/setEmpresa", idEmpresa);
        store.commit("Contratos/NuevoContrato/setSubfactura", subfactura);
      }
    },
    async initTipoContrato() {
      const resp = await axios.post("/execute", {
        method: "CLI.GetTipoContratoSegunCantidadByClienteId",
        parameters: [
          { name: "id_cliente", value: this.$route.params.id_cliente },
        ],
      });
      if (resp.data.ok) {
        const tipoContrato = get(
          resp.data,
          "result[0][0].id_contrato_tipos",
          null,
        );
        store.commit("Contratos/NuevoContrato/setContratoTipo", tipoContrato);
      }
    },
    cambiarCantidadGrupos(cantidad) {
      this.cantidadGrupos = cantidad;
    },
    async submit() {
      const idCliente = this.$route.params.id_cliente;

      let mensaje = [];
      const EmpresaPropia =
        this.$store.state.Contratos.NuevoContrato.empresaPropia;
      if (EmpresaPropia === null) {
        mensaje.push(`Empresa propia no puede ser nulo.`);
      }
      if (this.$store.state.Contratos.NuevoContrato.avlChip === null) {
        mensaje.push(`AvlChip no puede ser nulo.`);
      }
      if (this.$store.state.Contratos.NuevoContrato.vehiculo === null) {
        mensaje.push(`Vehículo no puede ser nulo.`);
      }
      if (this.$store.state.Contratos.NuevoContrato.contratoTipo === null) {
        mensaje.push(`ContratoTipo no puede ser nulo.`);
      }
      if (this.$store.state.Contratos.NuevoContrato.vendedor === null) {
        mensaje.push(`Vendedor no puede ser nulo.`);
      }
      if (this.$store.state.Contratos.NuevoContrato.instalador === null) {
        mensaje.push(`Instalador no puede ser nulo.`);
      }
      const empresaDelCliente =
        this.$store.state.Contratos.NuevoContrato.empresa;
      if (
        EmpresaPropia &&
        EmpresaPropia.id_empresas_propias != 0 &&
        empresaDelCliente === null
      ) {
        mensaje.push(`Empresa del cliente no puede ser nulo.`);
      }
      if (
        empresaDelCliente != null &&
        this.$store.state.Contratos.NuevoContrato.subfactura === null
      ) {
        mensaje.push(
          `Ha seleccionado una empresa, por favor seleccione subfactura.`,
        );
      }

      if (this.$refs.viaticosForm) {
        const viaticosErrors = this.$refs.viaticosForm.validateForm();
        if (viaticosErrors.length > 0) {
          mensaje.push(...viaticosErrors);
        }
      }

      if (mensaje.length) {
        return this.$msgBoxOk(
          mensaje.map((msj) => this.$createElement("p", msj)),
          {
            title: this.$createElement("h4", "Controlar formulario"),
          },
        );
      }

      if (this.cantidadGrupos > 0 && isNull(this.grupo)) {
        const shouldContinue = await this.$bvModal.msgBoxConfirm(
          `Este cliente tiene ${this.cantidadGrupos} grupos y no elegiste ninguno. Deseas continuar?`,
        );
        if (!shouldContinue) return;
      }

      try {
        const { data } = await this.$store.dispatch(
          "Contratos/NuevoContrato/submitContrato",
          { idCliente },
        );

        if (get(data, "ok", null)) {
          this.$msgBoxOk(`Éxito!`).then(() => {
            this.volver();
          });
        } else {
          const message = get(data, "message", "NO_HUBO_MENSAJE");
          return this.$msgBoxOk(message);
        }
      } catch (e) {
        this.$msgBoxOk(e.toString());
      }
    },
    volver() {
      this.$router.push(
        `/admin/clientes/${this.$route.params.id_cliente}/contratos`,
      );
    },
  },
  data: () => ({
    clienteId: null,
    isLoading: true,
    cantidadGrupos: 0,
    cobrarViaticos: false,
  }),
  computed: {
    vehiculo: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.vehiculo;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setVehiculo", val);
      },
    },
    grupo: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.grupo;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setGrupo", val);
      },
    },
    contratoTipo: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.contratoTipo;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setContratoTipo", val);
      },
    },
    avlChip: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.avlChip;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setAvlChip", val);
      },
    },
    ventaNotas: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.ventaNotas;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setVentaNotas", val);
      },
    },
    monto: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.monto;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setMonto", val);
      },
    },
    descripcionDeViaticos: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.descripcionDeViaticos;
      },
      set(val) {
        this.$store.commit(
          "Contratos/NuevoContrato/setDescripcionDeViaticos",
          val,
        );
      },
    },
    fechaAlta: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.fechaAlta;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setFechaAlta", val);
      },
    },
    viaticos: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.viaticos;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setViaticos", val);
      },
    },
  },
};
</script>

<style scoped></style>
